<template>
  <svg
    v-if="!showTick || (showTick && progress !== 100)"
    :width="diameter"
    :height="diameter"
    :viewBox="`0 0 ${diameter} ${diameter}`"
    style="transform: rotate(-90deg)"
    :class="{spin: isInfinite}" >
    <circle
      :r="radius - strokeWidth / 2"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke="background"
      :stroke-width="strokeWidth" />
    <circle
      :r="radius - strokeWidth / 2"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke="foreground"
      :stroke-width="strokeWidth"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="offset" />
  </svg>
  <SBIcon
    v-else
    :icon="SBIconList.DONE_TICK_THIN"
    :color="SBColors.bluePrimary"
    :size="diameter" />
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'CircleSpinner',
  components: {
    SBIcon,
  },
  props: {
    diameter: {
      type: Number,
      default: 25,
    },
    progress: {
      type: Number,
      default: 100,
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
    background: {
      type: String,
      default: 'transparent',
    },
    foreground: {
      type: String,
      default: '#2680EB',
    },
    infinite: {
      type: Boolean,
      default: false,
    },
    /** Shows the tick icon instead of progress. Useful for finished actions. */
    showTick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infiniteProgress: 15,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    isInfinite() {
      return this.infinite || (!this.progress && this.progress !== 0);
    },
    radius() {
      return this.diameter / 2;
    },
    circumference() {
      return Math.PI * (this.diameter - this.strokeWidth);
    },
    offset() {
      return this.circumference * ((100 - (this.isInfinite ? this.infiniteProgress : this.progress)) / 100);
    },
  },
  mounted() {
    if (this.isInfinite) {
      setInterval(() => {
        this.infiniteProgress = this.infiniteProgress > 15 ? 15 : 85;
      }, 1000);
    }
  },
};
</script>

<style scoped>
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

circle {
  transition: all 200ms ease-in;
}
</style>
